// Sticky order bar (sections/cl-sticky-order.liquid).
// Shows the chosen build and price, appears after the first screen and hides while the
// configurator or the footer is on screen. Its button scrolls to the configurator.
if (!customElements.get('cl-sticky-order')) {
  customElements.define(
    'cl-sticky-order',
    class ClStickyOrder extends HTMLElement {
      connectedCallback() {
        this.buildEl = this.querySelector('[data-cl-sticky-build]');
        this.priceEl = this.querySelector('[data-cl-sticky-price]');
        this.blockers = new Set();

        this.onBuild = ({ detail }) => this.showBuild(detail);
        this.onScroll = () => this.updateVisibility();
        document.addEventListener('cl:build', this.onBuild);
        window.addEventListener('scroll', this.onScroll, { passive: true });

        // The configurator may have announced its build before this bar was ready.
        const configurator = document.querySelector('cl-configurator');
        if (configurator && configurator.lastBuild) this.showBuild(configurator.lastBuild);

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((e) => (e.isIntersecting ? this.blockers.add(e.target) : this.blockers.delete(e.target)));
              this.updateVisibility();
            },
            { threshold: 0.15 }
          );
          [document.getElementById('customize'), document.querySelector('.cl-footer')].filter(Boolean).forEach((el) => this.observer.observe(el));
        }
        this.updateVisibility();
      }

      disconnectedCallback() {
        document.removeEventListener('cl:build', this.onBuild);
        window.removeEventListener('scroll', this.onScroll);
        if (this.observer) this.observer.disconnect();
        document.body.classList.remove('cl-sticky-on');
      }

      showBuild(detail) {
        if (detail.label) this.buildEl.textContent = detail.label;
        if (detail.price) this.priceEl.textContent = detail.price;
      }

      updateVisibility() {
        const show = window.scrollY > window.innerHeight * 0.6 && this.blockers.size === 0;
        this.classList.toggle('is-visible', show);
        document.body.classList.toggle('cl-sticky-on', show);
      }
    }
  );
}
